import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';

const DeletionRequests = () => {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getDeletionRequests();
  }, []);

  const getDeletionRequests = () => {
    setIsLoading(true);
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-deletion-requests", {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      if (res.data.status) {
        setRequests(res.data.requests || []);
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
      setIsLoading(false);
    }).catch(err => {
      globalErrorHandler(err, navigate);
      setIsLoading(false);
    });
  };

 const processDeletion = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This will permanently delete this deletion request. This action cannot be undone!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete permanently!",
  }).then(result => {
    if (result.isConfirmed) {
      // FIXED: Changed from "/admin/delete-floor" to your actual deletion request route
      axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/process-deletion-request", { id }, {
        withCredentials: true
      }).then(res => {
        if (res.data.status) {
          Swal.fire("Deleted!", "The deletion request record have been deleted.", "success");
          getDeletionRequests();
        } else {
          Swal.fire("Error", res.data.message, "error");
        }
      }).catch(err => globalErrorHandler(err, navigate));
    }
  });
};
  return (


        <div className="container-fluid px-4 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Account Deletion Requests</h3>
            </div>

      <div className="table-responsive">
                        <table className="table table-bordered table-hover shadow-sm nowrap">
                            <thead className="table-success">
          <tr>
            <th style={{ width: "5%" }}>#</th>
            <th style={{ width: "20%" }}>Guest Name</th>
            <th style={{ width: "45%" }}>Reason / Remarks</th>
            <th style={{ width: "15%" }}>Date & Time</th>
            <th style={{ width: "10%" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="5" className="text-center py-3">Loading requests...</td></tr>
          ) : (
            <>
              {requests.length === 0 ? (
                <tr><td colSpan="5" className="text-center text-muted py-3">No active account deletion requests found.</td></tr>
              ) : (
                requests.map((req, index) => (
                  <tr key={req.id}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{req.name}</strong>
                      {req.email && <div className="small text-muted">{req.email}</div>}
                    </td>
                    <td>
                      <p className="mb-0 small text-wrap">
                        {req.remarks}
                      </p>
                    </td>
                    <td>
                          {req.deleted_at
                            ? new Date(req.deleted_at + "Z").toLocaleString(undefined, {
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : "-"}
                        </td>
                    <td>
                      <Button 
                        variant="danger" 
                        size="sm" 
                        className="shadow-sm" 
                        onClick={() => processDeletion(req.id)}
                      >
                        <i className="bi bi-trash-fill me-1"></i> Delete
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default DeletionRequests;